module.exports = __webpack_public_path__ + "img/Free-Top-Picture-Offer.0b189d4b.png";